(function () {
    const loaderButtons = document.querySelectorAll('.btn-spinner, .btn');

    loaderButtons.forEach((button) => {
        if (button.querySelector('.spinner-border')) {
            button.classList.remove('loading');

            button.addEventListener('click', () => {
                button.classList.add('loading');
            });
        }
    });

    // fix para eliminar loader en navegadores que almacenan scripts en cache al pulsar boton de volver
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            loaderButtons.forEach((button) => {
                button.classList.remove('loading');
            });
        }
    });

    // Ocultar loader en botones dentro de modals y offcanvas cuando estos han sido ocultados

    function hideLoaderOnChildButtons(event) {
        event.target.querySelectorAll('.btn-spinner, .btn').forEach((button) => {
            button.classList.remove('loading');
        });
    }

    const offCanvas = document.querySelectorAll('.offcanvas');
    offCanvas.forEach((offCanvas) => {
        offCanvas.addEventListener('hidden.bs.offcanvas', hideLoaderOnChildButtons);
    });

    const modals = document.querySelectorAll('.modal');
    modals.forEach((modal) => {
        modal.addEventListener('hidden.bs.modal', hideLoaderOnChildButtons);
    });
})();
